import * as angular from 'angular';
import { virtualExperienceDashbaordComponent } from './virtual-experience-dashboard.component';
import { topLevelVirtualExperienceComponent } from './top-level-virtual-experience.component';


export const VirtualExperienceModule = angular.module('virtualExperienceModule', [])
  .component('topLevelVirtualExperience', topLevelVirtualExperienceComponent )
  .component('virtualExperienceDashboard', virtualExperienceDashbaordComponent )
  .name;
